<template>
    <div class="innerBox p-0">

        <!-- QR Registration Control Start -->
        <div style="padding: 1.5rem">
            <h2 class="section--title">QR Registration Control</h2>
            <div class="row mt-3">
                <div class="col-md-4">
                    <div class="innerBox">
                        <p class="chart--title">Stock QR</p>
                        <p class="stats--value">{{ statsData ? numberWithCommas(parseInt(statsData.mapping_qr) + parseInt(statsData.onhand_stock)) : 'Loading...' }}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="innerBox">
                        <p class="chart--title">QR On-Hand Dealer</p>
                        <p class="stats--value">{{ statsData ? numberWithCommas(statsData.onhand_stock) : 'Loading...' }}</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="innerBox">
                        <p class="chart--title">Mapping QR</p>
                        <p class="stats--value">{{ statsData ? numberWithCommas(statsData.mapping_qr) : 'Loading...' }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- QR Registration Control End -->

        <div class="section--divider pt-0"></div>

        <!-- QR Assignment Start -->
        <div style="padding: 1.5rem">
            <div class="row">
                <div class="col-md-10">
                    <h3 class="chart--title">QR Assignment</h3>
                </div>
                <div class="col-md-2 monitoringSelect">
                    <multiselect 
                        :options="options.dealer.map(x => x.code)"
                        :custom-label="opt => options.dealer.find(x => x.code == opt).name"
                        placeholder="All Dealers"
                        v-model="filter.dealer" 
                    />
                </div>
            </div>

            <!-- <vue-universal-table
                v-if="tableData"
                :data="tableDataList"
                :fields="vue_universal_table.fields"
                :buttons="vue_universal_table.buttons"
                :fixed_header="true"
                :disable_sort="true"
                tbody_height="400px"
                @onEditAssingedStock="errorPrint('test')"
            ></vue-universal-table> -->

            <monitoring-qr-table
                v-if="tableData"
                :data="tableDataList"
                @editAssingedStock="editAssingedStock"
            ></monitoring-qr-table>

        </div>
        <!-- QR Assignment End -->

    </div>
</template>

<script>
    import multiselect from 'vue-multiselect';
    import moment from 'moment';

    import monitoringQrTable from './children/monitoringQrTable'

    export default {
        data () {
            return {
                vue_universal_table : {
                    fields : [
                        {title:'Dealer Code', variable:'dealer_code'},
                        {title:'Dealer Name', variable:'dealer_name'},
                        // {title:'Last Updated', variable:'updated_at', date_format:'DD MMMM YYYY - HH:mm'},
                        {title:'On-Hand Stock', variable:'onhand_stock', number_formatting: true},
                        {title:'Assigned Stock', variable:'assigned_stock', number_formatting: true},
                        {title:'Mapping QR', variable:'mapping_qr', number_formatting: true}
                    ],
                    buttons : [
                        {title:'editAssingedStock', class:"btn-link fas fa-edit", style:"color: grey; border: 1px solid grey"},
                        // {title:'Delete', class:"btn-link fas fa-trash-alt", style:'color:red; border: 1px solid grey'},
                    ]
                },
                options : {
                    dealer : this.$store.getters.getDealer(),
                },
                filter : {
                    dealer : '',
                },
                dummyData : null,
                statsData : null,
                tableData : null,
            }
        },
        components : {
            multiselect,
            monitoringQrTable,
        },
        mounted () {
            this.generateDummyData();
            this.fetchData();
        },
        computed : {
            tableDataList () {
                if (this.filter.dealer == null || this.filter.dealer == '') return this.tableData;
                else return this.tableData.filter(x=>x.dealer_code == this.filter.dealer);
            }
        },
        methods : {
            generateDummyData () {
                let data = [];
                let current = moment();
                for (var i = 0; i < 20; i++) {
                    current = current.subtract(this.randomInt(1000, 100000), 'second');
                    data.push({
                        dealer : `A000${20 + i*2}`,
                        updated_at : current.format("YYYY-MM-DD HH:mm:ss"),
                        onHandStock : this.randomInt(10000, 500000),
                        assignedStock : this.randomInt(10000, 500000),
                        mappingQr : this.randomInt(10000, 500000)
                    })
                }
                this.dummyData = data;
            },
            fetchData () {
                this.statsData = null;
                this.tableData = null;

                this.$http.get(`/api/h1/qrcode-monitoring`)
                .then((resp)=>{
                    this.tableData = resp.data.data.table;
                    this.statsData = resp.data.data.summary[0];
                })
                .catch((err)=>{console.log(err)})
            },
            async editAssingedStock (currData) {
                const { value: newAssignedStock } = await this.$swal.fire({
                    title: `Input New Assigned Stock`,
                    html: `<p>Dealer: ${currData.dealer_code}</p><br><p>Current Assigned Stock: ${this.numberWithCommas(currData.assigned_stock)}</p>`,
                    input: 'text',
                    inputLabel: 'New Assigned Stock Value',
                    showCancelButton: true,
                    inputValidator: (value) => {
                        if (!value) {
                            return 'Input is required!'
                        } else if (isNaN(value)) {
                            return 'Input must be a number!'
                        } else if (parseInt(value) < 0) {
                            return 'Input cannot be a negative value!'
                        }
                    }
                })

                if (newAssignedStock) {
                    let payload = {
                        id : currData.id,
                        assigned_stock : newAssignedStock
                    };

                    this.$http.put(`/api/h1/update-monitoring`, payload)
                    .then(async (resp)=>{
                        await this.$swal.fire({
                            'title' : 'Success',
                            'text' : `Dealer ${currData.dealer_code} has successfully been assigned with ${newAssignedStock} qrcodes.`,
                            'icon' : 'success'
                        })
                        this.fetchData();
                    })
                    .catch((err)=>{console.log(err)})
                }
            }
        }
    }
</script>

<style>
    .monitoringSelect .multiselect__tags  {
        box-shadow: 0px 2px 6px #0000001A;
        background-color: #FFFFFF !important;
        padding: 0 40px 0 12px;
        min-height: 32px;

        display: table;
        width: 100%;
    }

    .monitoringSelect .multiselect__single , .monitoringSelect .multiselect__input , .monitoringSelect .multiselect__input::placeholder , .monitoringSelect .multiselect__placeholder {
        background-color: #FFFFFF !important;
        color: #707070;

        vertical-align: middle;
        padding: 0;
        font: normal normal 500 10px/11px Ubuntu;

        display: table-cell;
        vertical-align: middle;

    }

    .monitoringSelect .multiselect__select {
        height: 32px;
    }
    
    .monitoringSelect .multiselect__select:before{
        border-color: #707070 transparent transparent;
    }

    .monitoringSelect:disabled .multiselect__select {
        background-color: #707070
    }
</style>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Ubuntu:wght@500;700&display=swap');

    .section--title {
        margin: 0;
        font: normal normal 500 24px/28px Ubuntu;
        color: #707070;
    }

    .chart--title {
        margin: 0;
        font: normal normal 500 18px/21px Ubuntu;
        color: #707070;
    }

    .stats--value {
        margin: 10px 0 0 0;
        font: normal normal 700 40px/44px Ubuntu;
        color: #707070;
    }

    .section--divider {
        width: 100%;
        height: 17px;
        background-color: #F2F2F2;
    }

</style>